<template>
  <div style="display: none;"></div>
</template>
<script>
import Notice from './notice';

export default {
  name: 'CommonXDToast',

  inject: ['rocketOn'],

  mounted() {
    this.initEventListener();
  },
  
  methods: {
    onEvent(event, cb) {
      if (this.rocketOn) {
        this.rocketOn(`rocket:remote:common/xd-toast:${event}`, false, (e) => {
          cb && cb(e);
        });
      }
    },
    initEventListener() {
      this.onEvent('show-info', (content, duration) => {
        this.showInfo(content, duration);
      });
    },
    showInfo(content, duration = 3) {
      Notice.info({
        content,
        duration,
      });
    },
  },
};
</script>